import {
  DocumentNode,
  QueryHookOptions,
  TypedDocumentNode,
  useQuery,
} from "@apollo/client";
import { shape } from "prop-types";
import { useMemo } from "react";

import usePrevious from "web/hooks/usePrevious";

import { getAccessToken } from "web/External/utils/authorization";

const useQueryWrapper = <T = unknown>(
  query: DocumentNode | TypedDocumentNode,
  options?: QueryHookOptions
) => {
  const accessToken = getAccessToken();
  const optionsWithToken = useMemo(() => {
    if (!accessToken) {
      return options;
    }

    return {
      ...(options || {}),
      context: {
        ...(options?.context || {}),
        headers: {
          ...(options?.context?.headers || {}),
          authorization: `Bearer ${accessToken}`,
        },
      },
    };
  }, [options, accessToken]);

  const { loading, error, data, fetchMore } = useQuery<T>(
    query,
    optionsWithToken
  );
  const previousData = usePrevious(data);

  return {
    loading,
    error,
    data:
      loading &&
      (!data || !Object.keys(data).length) &&
      previousData &&
      Object.keys(previousData).length
        ? previousData
        : data,
    fetchMore,
  };
};

useQueryWrapper.propTypes = {
  query: shape({}).isRequired,
  options: shape({}).isRequired,
};

export default useQueryWrapper;
